import { RootState } from "../store/configureStore";

export interface UserDetailsState extends BaseReducerState {
  data: AccountUser;
  updatedKeys: (keyof AccountUser)[];
}
export interface UserDetailsRequestAction {
  type: "REQUEST_FETCH_USER_DETAILS";
}
export interface UpdateUserDetailsAction {
  type: "REQUEST_UPDATE_USER_DETAILS";
  updatedKeys: (keyof AccountUser)[];
}
export interface UserDetailsRequestSuccessAction {
  type:
    | "REQUEST_FETCH_USER_DETAILS_SUCCESS"
    | "REQUEST_UPDATE_USER_DETAILS_SUCCESS";
  userDetails: AccountUser;
}
export interface UserDetailsRequestFailedAction {
  type:
    | "REQUEST_FETCH_USER_DETAILS__FAILED"
    | "REQUEST_UPDATE_USER_DETAILS__FAILED";
  error: string;
}
export interface UserDetailsDefaultAction {
  type: "SET_USER_DETAILS_DEFAULT";
}
export type UserDetailsActions =
  | UserDetailsRequestAction
  | UpdateUserDetailsAction
  | UserDetailsRequestSuccessAction
  | UserDetailsRequestFailedAction
  | UserDetailsDefaultAction;
export const selectUserDetailsState = (rootState: RootState) =>
  rootState.userDetails;
export const userDetailsReducerDefaultState: UserDetailsState = {
  data: {} as AccountUser,
  updatedKeys: [],
  loading: false,
  error: "",
};
const userDetailsReducer = (
  state = userDetailsReducerDefaultState,
  action: UserDetailsActions
) => {
  switch (action.type) {
    case "REQUEST_FETCH_USER_DETAILS":
      return {
        ...state,
        error: "",
        loading: true,
      };
    case "REQUEST_UPDATE_USER_DETAILS":
      return {
        ...state,
        error: null,
        updatedKeys: action.updatedKeys,
        loading: true,
      };
    case "REQUEST_FETCH_USER_DETAILS_SUCCESS":
    case "REQUEST_UPDATE_USER_DETAILS_SUCCESS":
      return {
        data: action.userDetails,
        error: "",
        loading: false,
        updatedKeys: [],
      };
    case "REQUEST_FETCH_USER_DETAILS__FAILED":
    case "REQUEST_UPDATE_USER_DETAILS__FAILED":
      return {
        ...state,
        loading: false,
        error: "",
        updatedKeys: [],
      };
    case "SET_USER_DETAILS_DEFAULT":
      return userDetailsReducerDefaultState;
    default:
      return state;
  }
};

export { userDetailsReducer as default };
